import { browserHistory } from './../../../../App';
import { IAppOnlyStore } from 'stores/AllStores';
import * as React from 'react';
import { observer, inject } from 'mobx-react';
import { UserProfileForm, UserProfileInfo, ChangePasswordForm } from '.';
import { SectionHeadline } from 'components/content';
const editIcon = require('assets/pen icon.svg');
const cancelIcon = require('assets/close orange icon.svg');

// Styles
const s = require('./ProfileSidebar.css');
const padlockIcon = require('assets/padlock-icon.svg');

// Component
@inject('store')
@observer
export class ProfileSidebar extends React.Component<IAppOnlyStore, {}> {
    constructor(props: any) {
        super(props);
    }

    public render() {
        const { user, sidebar } = this.props.store;

        return (
            <div className={s.profileSidebar}>

                <div className={s.profileSidebarInner}>
                    <SectionHeadline
                        title="User Profile"
                        button={user.userEdit
                            ? {
                                onClick: user.stopEditingUser,
                                label: 'Cancel editing',
                                icon: cancelIcon,
                            }
                            : {
                                onClick: user.startEditingUser,
                                label: '',
                                icon: editIcon,
                            }
                        }
                    />

                    {user.userEdit && <UserProfileForm /> || <UserProfileInfo />}

                    <SectionHeadline
                        title="Change Password"
                        button={user.userChangePassword
                            ? {
                                onClick: user.stopEditingUserPassword,
                                label: 'Cancel editing',
                                icon: cancelIcon,
                            }
                            : {
                                onClick: user.startEditingUserPassword,
                                label: '',
                                icon: editIcon,
                            }
                        }
                    />

                    {user.userChangePassword && <ChangePasswordForm /> }
                </div>

                <button className={s.logout} onClick={this.handleLogout} style={{ width: sidebar.width + 'px' }}>
                    <span>Logout</span>
                    <img src={padlockIcon} />
                </button>

            </div>
        );
    }

    private handleLogout = (e: React.MouseEvent<HTMLButtonElement>) => {
        browserHistory.push('/user/logout');
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/components/layout/Sidebar/Profile/ProfileSidebar.tsx